export default __webpack_public_path__ + "static/media/confirm-friend.2dda7e1f.svg";